// extracted by mini-css-extract-plugin
export default {"container":"_3pdmOymaGrN3SuT5OEjRlQ","label":"_1ffB6osf6GXYlwpQDODnmX","heading":"_2sA5KxzHmRQlQin5s6dMCe"};